async function setup() {
  const { AccordionsGroup } = await import('./AccordionGroup')
  document.querySelectorAll<HTMLElement>('.js-accordions-group').forEach(item => new AccordionsGroup(item))
}

document.addEventListener('DOMContentLoaded', () => {
  setup()
})
